import { createI18n } from 'vue-i18n'
import zhTW from './zh-TW.js'
import zhCN from './zh-CN.js'
import en from './en.js'
import ko from './ko.js'
import ar from './ar.js'
import vi from './vi.js'
import th from './th.js'

// 支持的语言列表
export const LANGUAGE_OPTIONS = [
  {
    code: 'zh-TW',
    name: '繁體中文',
    flag: '🇹🇼',
  },
  {
    code: 'zh-CN',
    name: '简体中文',
    flag: '🇨🇳',
  },
  {
    code: 'en',
    name: 'English',
    flag: '🇺🇸',
  },
  {
    code: 'ko',
    name: '한국어',
    flag: '🇰🇷',
  },
  {
    code: 'ar',
    name: 'العربية',
    flag: '🇸🇦',
  },
  {
    code: 'vi',
    name: 'Tiếng Việt',
    flag: '🇻🇳',
  },
  {
    code: 'th',
    name: 'ภาษาไทย',
    flag: '🇹🇭',
  },
]

// 默认语言
export const DEFAULT_LANGUAGE = 'zh-TW'

// 从localStorage获取语言设置，如果没有则使用默认语言
function getStoredLanguage() {
  const stored = localStorage.getItem('language')
  if (stored && LANGUAGE_OPTIONS.find((lang) => lang.code === stored)) {
    return stored
  }
  return DEFAULT_LANGUAGE
}

// 创建i18n实例
const i18n = createI18n({
  legacy: false, // 使用Composition API模式
  locale: getStoredLanguage(), // 当前语言
  fallbackLocale: DEFAULT_LANGUAGE, // 备用语言
  messages: {
    'zh-TW': zhTW,
    'zh-CN': zhCN,
    en: en,
    ko: ko,
    ar: ar,
    vi: vi,
    th: th,
  },
  // 全局注入
  globalInjection: true,
})

// 语言切换函数
export function setLanguage(locale) {
  if (LANGUAGE_OPTIONS.find((lang) => lang.code === locale)) {
    i18n.global.locale.value = locale
    localStorage.setItem('language', locale)
    document.documentElement.lang = locale
    return true
  }
  return false
}

// 获取当前语言
export function getCurrentLanguage() {
  return i18n.global.locale.value
}

// 获取语言显示名称
export function getLanguageName(code) {
  const lang = LANGUAGE_OPTIONS.find((l) => l.code === code)
  return lang ? lang.name : code
}

export default i18n
